import { useState, useEffect } from 'react'
import { Box, Link, Alert } from '@mui/material'
import { getAppClosed } from '@hooks/contract'
import Header from './Header'
import Footer from './Footer'
import './Layout.scss'

const Layout = ({ children }) => {
  const newAppLink = process.env.REACT_APP_NEW_URL
  const [isClosed, setIsClosed] = useState(false)

  useEffect(() => {
    let _interval = setInterval(() => {
      initialHandler()
    }, 15000)
    
    return () => {
      clearInterval(_interval)
    }
  })

  useEffect(() => {
    initialHandler()
  }, [])

  const initialHandler = async () => {
    setIsClosed(await getAppClosed())
  }

  return (
    <>
      <Header />
      <Box className="main">
        {isClosed && (
          <Alert
            severity="warning"
            sx={{ mt: 1 }}
          >
            This version of Presail is closed. Please remove your stakes and move to the
            <Link href={newAppLink.toLowerCase().includes('http') ? newAppLink : "//" + newAppLink} target="_blank" sx={{ ml: 1 }}>
              new version
            </Link>
            .
          </Alert>
        )}
        {children}
      </Box>
      <Footer />
    </>
  )
}

export default Layout